const getBaseUrl = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;

    var apiUrl = `${base_url}/fcb2024/fcb2024-api/api`;
    return apiUrl;
  } else {
    return "";
  }
};

const getBaseUrlMedia = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;

    var apiUrl = `${base_url}/fcb2024/fcb2024-api/media`;
    return apiUrl;
  } else {
    return "";
  }
};

const getBaseUrlRoot = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;

    var apiUrl = `${base_url}/fcb2024/fcb2024-fe`;
    return apiUrl;
  } else {
    return "";
  }
};

// const CONFIG = {
//   URL: getBaseUrl(),
//   URL_MEDIA: getBaseUrlMedia(),
//   URL_ROOT: getBaseUrlRoot(),
// };

const CONFIG = {
  URL: "https://fcb2024-api.eventqiu.com/api",
  URL_MEDIA: "https://fcb2024-api.eventqiu.com/media",
  URL_ROOT: "https://fcb2024.eventqiu.com",
};

// URL: "https://fcb-api.eventqiu.com/api",
// URL: "http://192.168.100.114/fcb/fcb-api/api",
export default CONFIG;
